var _defs, _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationTriangleYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 29.99,
    viewBox: "0 0 33 29.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffed00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    className: "cls-1",
    d: "M14.39,1.24.34,26.48a2.38,2.38,0,0,0,1,3.21h0a2.39,2.39,0,0,0,1.2.29H30.63A2.37,2.37,0,0,0,33,27.66a2.42,2.42,0,0,0-.28-1.18l-14-25.24a2.49,2.49,0,0,0-3.4-.92h0A2.41,2.41,0,0,0,14.39,1.24Zm3.54,10.48-.28,9.52H15.43l-.29-9.52Zm-1.4,14.71A1.44,1.44,0,1,1,18.05,25a1.46,1.46,0,0,1-1.48,1.44h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.43 21.24 17.65 21.24 17.93 11.72 15.14 11.72 15.43 21.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.17,24.91a1.44,1.44,0,0,0,1.36,1.52h0A1.43,1.43,0,0,0,18,25a1.44,1.44,0,0,0-2.87-.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleYellow);
export default __webpack_public_path__ + "static/media/exclamation-triangle-yellow.6bded0d134f7ec09484426e986dc9e4a.svg";
export { ForwardRef as ReactComponent };